import { Injectable } from '@angular/core';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { ApiService } from '@services/api/api.service';
import { SignalRService } from '@services/signalr/signal-rservice.service';
import { ToastrService } from 'ngx-toastr';
import { appSettings } from '../../modules/shared/components/appSettings';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  notifications: any = new Array();
  public showNotifications: boolean;
  constructor(private signalRService: SignalRService,
    private apiService: ApiService,
    private messageService: ToastrService,
    private auth: IdentityAuthService) {
   
      this.loadNotifications();

    this.signalRService.newNotification.subscribe(data => {
      data.timePassed = this.calcMinutesPassed(data.dateAdded);
      this.notifications.unshift(data);
      this.messageService.info(data.title, "New Notification");
    })
    var self = this;
    setInterval(function () {
      self.notifications.forEach(i => {
        i.timePassed = self.calcMinutesPassed(i.dateAdded);
      })
    }, 60 * 1000); // 60 * 1000 milsec
  }

  public async loadNotifications() {
    await this.auth.ensureAppSettingsLoaded();
    this.apiService.get('/api/Notification/perUser')
      .subscribe(results => {
        results.forEach(i => {
          i.timePassed = this.calcMinutesPassed(i.dateAdded);
        })
        this.notifications = results;
      }, err => {
      });
  }

  public calcMinutesPassed(date) {
    var currrentDate: any = new Date();
    var dateAdded: any = new Date(date);
    var diffMs = (currrentDate - dateAdded); // milliseconds between now & Christmas
    var diffS = Math.round(((diffMs % 86400000) % 3600000) / 1000); // seconds between now & Christmas
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    var diffDays = Math.floor(diffMs / 86400000); // days

    if (diffDays > 0)
      return `${diffDays} day(s) ago`;
    if (diffHrs > 0)
      return `${diffHrs} hour(s) ago`;
    if (diffMins > 0)
      return `${diffMins} min(s) ago`;
    return 'just now'
  }
}
